import React from 'react';

export default function Tip(props) {
  return (
    <div style={{ textAlign: "center", color: "#888", fontSize: "0.9em" }}>
      <em>{props.children}</em>
    </div>
  )
}
